import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import red from '@material-ui/core/colors/red';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ShareIcon from '@material-ui/icons/Share';
import ThumbUp from '@material-ui/icons/ThumbUp';
import ThumbDown from '@material-ui/icons/ThumbDown';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import {TwitterIcon, TwitterShareButton} from "react-share";
import Button from "@material-ui/core/Button/Button";
import Pie3D from "react-pie3d";
import Divider from "@material-ui/core/Divider/Divider";
import firebase from "./fire";
import TextField from "@material-ui/core/TextField/TextField";
import Chip from "@material-ui/core/Chip/Chip";
import DoneIcon from "@material-ui/core/SvgIcon/SvgIcon";

import firebasesdk from 'firebase';

var format = require('date-format');
format.asString(); //defaults to ISO8601 format and current date.
format.asString(new Date()); //defaults to ISO8601 format



const styles = theme => ({
  card: {
    maxWidth: 500,
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  actions: {
    display: 'flex',
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: red[500],
  },
});

class NewIdea extends React.Component {
  state = { expanded: false , commentText: ""};

  handleExpandClick = () => {
    this.setState(state => ({ expanded: !state.expanded }));
  };
  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });

  };

  handleSignupButtonClick = () => {
    let provider = new firebasesdk.auth.GoogleAuthProvider()


    firebase.auth().signInWithPopup(provider).then(function(result) {
      // This gives you a Google Access Token. You can use it to access the Google API.
      var token = result.credential.accessToken;
      // The signed-in user info.
      var user = result.user;
      // setter
      localStorage.setItem('currentuser', user)


      // ...
    }).catch(function(error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
      // The email of the user's account used.
      var email = error.email;
      // The firebase.auth.AuthCredential type that was used.
      var credential = error.credential;
      // ...
    });
  }

  componentDidMount () {
    var postId = this.props.ref_id;

    var user = firebase.auth().currentUser;
   if(user) {
     firebase.database().ref('uservotes/' + user.uid + "/" + postId).once('value').then((snapshot) => {
       var alreadyVoted = snapshot.val()
       this.setState({alreadyVoted: alreadyVoted})
     });
   }
    firebase.auth().onAuthStateChanged((user) => {
      if(user) {
        firebase.database().ref('uservotes/' + user.uid + "/" + postId).once('value').then((snapshot) => {
          var alreadyVoted = snapshot.val()
          this.setState({alreadyVoted: alreadyVoted})
        });
      }

    });
  }

  handleButtonClick = (button_name) => {

    var postId = this.props.ref_id;

    var user = firebase.auth().currentUser;

    firebase.database().ref('uservotes/'+user.uid).push({

    });

    firebase.database().ref('uservotes/'+user.uid).update({
      [postId]: postId
    });
    firebase.database().ref('uservotes/'+user.uid + "/" + postId).once('value').then((snapshot) => {
      var alreadyVoted = snapshot.val()
      this.setState({alreadyVoted: alreadyVoted})
    });
    let new_arr = [...this.props.post.data];
    switch(button_name){

      case "yes":
        new_arr[0].value += 1;
        break;
      default:
    }
    var postKey = this.props.ref_id;
    var updates = {};
    updates['/posts/' + postKey+'/data/'] = new_arr;
    updates['/posts/' + postKey+'/votes/'] = this.props.post.votes + 1;

    firebase.database().ref().update(updates);
    this.setState({alreadyVoted: true})
  }

  handleCommentSend = () => {



    let new_arr = this.props.post.comments ? [...this.props.post.comments] : []




    new_arr.push(
      {
        comment_text: this.state.commentText,
        username: "anon",
        created_at: new Date()
      })
    var postKey = this.props.ref_id;
    var updates = {};
    updates['/posts/' + postKey+'/comments/'] = new_arr;

    firebase.database().ref().update(updates);

    this.setState({
      commentText: "",
      alreadySubmitted: true,

    });
  }

  render() {

    var user = firebase.auth().currentUser;


    var postId = this.props.ref_id;


    const { classes } = this.props;
    const can_be_posted = ( this.state.commentText.length > 2);;
    return (
      <Card style={{height: "100%"}}className={classes.card}>
        <CardHeader
          avatar={
            <IconButton aria-label="Add to favorites">
              <TwitterShareButton
                url={"https://1001problems.com"}
                title={"Decide if this is a problem worth solving: " + this.props.post.description}
                hashtags={["1001problems","greatproblems","solvethisproblem"]}
              >
                <TwitterIcon
                  size={32}
                  round />
              </TwitterShareButton>
            </IconButton>
          }
          // action={
          //   <IconButton>
          //     <MoreVertIcon />
          //   </IconButton>
          // }
          title={this.props.post.name ? this.props.post.name : ""}
          subheader={ (typeof this.props.post.created_at !== 'undefined') ?
            format.asString('MM/dd/yy-hh:mm', new Date(parseInt(this.props.post.created_at )))
            : ""}
        />
        {/*<CardMedia*/}
          {/*className={classes.media}*/}
          {/*image="/static/images/cards/paella.jpg"*/}
          {/*title="Paella dish"*/}
        {/*/>*/}
        <CardContent>
          <Typography component="p">
            {this.props.post.description}
          </Typography>

          <Pie3D data={this.props.post.data}/>
          <Typography variant="body2">Votes: {this.props.post.votes} </Typography>
          <Typography variant="body2">{this.props.post.comments ? this.props.post.comments.length : 0} Comments</Typography>

        </CardContent>
        <CardActions className={classes.actions} disableActionSpacing>


          {
            (user != null) ?

               this.state.alreadyVoted ?   <Chip
                  icon={<DoneIcon />}
                  label="Thanks for the vote!"
                  style={{    margin: "1rem" }}
                  color="secondary"
                /> :
                <React.Fragment>
                  <IconButton onClick={()=> this.handleButtonClick('yes')}   aria-label="Vote up">
                    <ThumbUp/>
                  </IconButton>
                  <IconButton onClick={()=> this.handleButtonClick('no')} aria-label="Vote up">
                    <ThumbDown/>
                  </IconButton>
                </React.Fragment>

           :

            <Typography component="p">Signin to vote!</Typography>

          }





          {/*<IconButton aria-label="Add to favorites">*/}
            {/*<FavoriteIcon />*/}
          {/*</IconButton>*/}
          {/*<IconButton aria-label="Share">*/}
            {/*<ShareIcon />*/}
          {/*</IconButton>*/}
          <IconButton
            className={classnames(classes.expand, {
              [classes.expandOpen]: this.state.expanded,
            })}
            onClick={this.handleExpandClick}
            aria-expanded={this.state.expanded}
            aria-label="Show more"
          >
            <ExpandMoreIcon />
          </IconButton>
        </CardActions>
        <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
          <CardContent style={{textAlign: "left"}}>

            {this.props.post.comments ?
              this.props.post.comments.map( (el, idx)=>
                <div key={idx} style={{marginBottom: "0.5rem", marginTop: "0.5rem"}}>
                  <Typography component="p">
                    {el.comment_text}
                  </Typography>
                  <Typography variant="caption">
                    {el.username} - { format.asString('MM/dd/yy-hh:mm', new Date(el.created_at)) }
                    </Typography>


              <Divider/>
                </div>

              )
            : null}

            <form  noValidate autoComplete="off" style={{width: "100%"}}>
              {/*<TextField*/}
              {/*id="name"*/}
              {/*label="Short title for the problem"*/}
              {/*className={classes.textField}*/}
              {/*value={this.state.name}*/}
              {/*onChange={this.handleChange('name')}*/}
              {/*margin="normal"*/}
              {/*/>*/}

              <TextField
                style={{width: "100%"}}
                id="textarea"
                label="Comment"
                placeholder="Post your comment"
                multiline
                rows="4"

                onChange={this.handleChange('commentText')}
                value={this.state.commentText}
                margin="normal"
              />



            </form>
            {/*{ this.state.alreadySubmitted ?   <Chip*/}
                {/*icon={<DoneIcon />}*/}
                {/*label="Thanks for the comment!"*/}
                {/*style={{    margin: "1rem" }}*/}
                {/*color="secondary"*/}
              {/*/> :*/}
              {/*<Button disabled = {!can_be_posted} variant="outlined" color="primary" onClick={()=> this.handleCommentSend()}>*/}
                {/*Post*/}

              {/*</Button>}*/}


              <Button disabled = {!can_be_posted} variant="outlined" color="primary" onClick={()=> this.handleCommentSend()}>
                Post

              </Button>
          </CardContent>
        </Collapse>
      </Card>
    );
  }
}

NewIdea.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(NewIdea);






// WEBPACK FOOTER //
// ./src/NewIdea.js